import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private swUpdate: SwUpdate, private snackBar: MatSnackBar) {
    this.swUpdate.versionUpdates.subscribe(event => {
      if (event.type === 'VERSION_READY') {
        const snack = this.snackBar.open('Nueva versión disponible', 'Actualizar', {
          duration: 0, // Mantiene el aviso visible indefinidamente
          verticalPosition: 'top'
        });

        snack.onAction().subscribe(() => {
          // Limpia session y localStorage al actualizar
          localStorage.clear(); 
          sessionStorage.clear();
          // Activa y recarga para aplicar cambios
          this.swUpdate.activateUpdate().then(() => window.location.reload()); 
        });
      }
    });
  }

}